function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { __awaiter } from "tslib";
import { Component } from "../../core/render/Component";
import { List } from "../../core/util/List";
import { Color } from "../../core/util/Color";
import { percentInterpolate } from "../../core/util/Animation";
import { Percent } from "../../core/util/Percent";
import * as $array from "../../core/util/Array";
import * as $type from "../../core/util/Type";
import * as $time from "../../core/util/Time";
import { p100 } from "../../core/util/Percent";
import { Container } from "../../core/render/Container";
import { Label } from "../../core/render/Label";
/**
 * A base class for all series.
 */
export var Series = /*#__PURE__*/function (_Component) {
  _inherits(Series, _Component);
  var _super2 = _createSuper(Series);
  function Series() {
    var _this;
    _classCallCheck(this, Series);
    _this = _super2.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_aggregatesCalculated", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_selectionAggregatesCalculated", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_dataProcessed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_psi", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_pei", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * A chart series belongs to.
     */
    Object.defineProperty(_assertThisInitialized(_this), "chart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * List of bullets to use for the series.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/bullets/} for more info
     */
    Object.defineProperty(_assertThisInitialized(_this), "bullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new List()
    });
    /**
     * A [[Container]] series' bullets are stored in.
     *
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "bulletsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(_this._root, {
        width: p100,
        height: p100,
        position: "absolute"
      })
    });
    return _this;
  }
  _createClass(Series, [{
    key: "_afterNew",
    value: function _afterNew() {
      var _this2 = this;
      this.valueFields.push("value");
      _get(_getPrototypeOf(Series.prototype), "_afterNew", this).call(this);
      this.setPrivate("customData", {});
      this._disposers.push(this.bullets.events.onAll(function (change) {
        if (change.type === "clear") {
          _this2._handleBullets(_this2.dataItems);
        } else if (change.type === "push") {
          _this2._handleBullets(_this2.dataItems);
        } else if (change.type === "setIndex") {
          _this2._handleBullets(_this2.dataItems);
        } else if (change.type === "insertIndex") {
          _this2._handleBullets(_this2.dataItems);
        } else if (change.type === "removeIndex") {
          _this2._handleBullets(_this2.dataItems);
        } else if (change.type === "moveIndex") {
          _this2._handleBullets(_this2.dataItems);
        } else {
          throw new Error("Unknown IListEvent type");
        }
      }));
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      this.bulletsContainer.dispose(); // can be in a different parent
      _get(_getPrototypeOf(Series.prototype), "_dispose", this).call(this);
    }
  }, {
    key: "startIndex",
    value: function startIndex() {
      var len = this.dataItems.length;
      return Math.min(this.getPrivate("startIndex", 0), len);
    }
  }, {
    key: "endIndex",
    value: function endIndex() {
      var len = this.dataItems.length;
      return Math.min(this.getPrivate("endIndex", len), len);
    }
  }, {
    key: "_handleBullets",
    value: function _handleBullets(dataItems) {
      $array.each(dataItems, function (dataItem) {
        var bullets = dataItem.bullets;
        if (bullets) {
          $array.each(bullets, function (bullet) {
            bullet.dispose();
          });
          dataItem.bullets = undefined;
        }
      });
      this.markDirtyValues();
    }
    /**
     * Looks up and returns a data item by its ID.
     *
     * @param   id  ID
     * @return      Data item
     */
  }, {
    key: "getDataItemById",
    value: function getDataItemById(id) {
      return $array.find(this.dataItems, function (dataItem) {
        return dataItem.get("id") == id;
      });
    }
  }, {
    key: "_makeBullets",
    value: function _makeBullets(dataItem) {
      var _this3 = this;
      if (this._shouldMakeBullet(dataItem)) {
        dataItem.bullets = [];
        this.bullets.each(function (bulletFunction) {
          _this3._makeBullet(dataItem, bulletFunction);
        });
      }
    }
  }, {
    key: "_shouldMakeBullet",
    value: function _shouldMakeBullet(_dataItem) {
      return true;
    }
  }, {
    key: "_makeBullet",
    value: function _makeBullet(dataItem, bulletFunction, index) {
      var bullet = bulletFunction(this._root, this, dataItem);
      if (bullet) {
        var sprite = bullet.get("sprite");
        if (sprite) {
          sprite._setDataItem(dataItem);
          sprite.setRaw("position", "absolute");
          this.bulletsContainer.children.push(sprite);
        }
        bullet._index = index;
        bullet.series = this;
        dataItem.bullets.push(bullet);
      }
      return bullet;
    }
  }, {
    key: "_clearDirty",
    value: function _clearDirty() {
      _get(_getPrototypeOf(Series.prototype), "_clearDirty", this).call(this);
      this._aggregatesCalculated = false;
      this._selectionAggregatesCalculated = false;
    }
  }, {
    key: "_prepareChildren",
    value: function _prepareChildren() {
      var _this4 = this;
      _get(_getPrototypeOf(Series.prototype), "_prepareChildren", this).call(this);
      var startIndex = this.startIndex();
      var endIndex = this.endIndex();
      if (this.isDirty("heatRules")) {
        this._valuesDirty = true;
      }
      if (this.isPrivateDirty("baseValueSeries")) {
        var baseValueSeries = this.getPrivate("baseValueSeries");
        if (baseValueSeries) {
          this._disposers.push(baseValueSeries.onPrivate("startIndex", function () {
            _this4.markDirtyValues();
          }));
        }
      }
      var calculateAggregates = this.get("calculateAggregates");
      if (calculateAggregates) {
        if (this._valuesDirty && !this._dataProcessed) {
          if (!this._aggregatesCalculated) {
            this._calculateAggregates(0, this.dataItems.length);
            this._aggregatesCalculated = true;
          }
        }
        if ((this._psi != startIndex || this._pei != endIndex) && !this._selectionAggregatesCalculated) {
          if (startIndex === 0 && endIndex === this.dataItems.length && this._aggregatesCalculated) {
            // void
          } else {
            this._calculateAggregates(startIndex, endIndex);
          }
          this._selectionAggregatesCalculated = true;
        }
      }
      if (this.isDirty("tooltip")) {
        var tooltip = this.get("tooltip");
        if (tooltip) {
          tooltip.hide(0);
          tooltip.set("tooltipTarget", this);
        }
      }
      if (this.isDirty("fill") || this.isDirty("stroke")) {
        var markerRectangle;
        var legendDataItem = this.get("legendDataItem");
        if (legendDataItem) {
          markerRectangle = legendDataItem.get("markerRectangle");
          if (markerRectangle) {
            if (this.isVisible()) {
              if (this.isDirty("stroke")) {
                var stroke = this.get("stroke");
                markerRectangle.set("stroke", stroke);
              }
              if (this.isDirty("fill")) {
                var fill = this.get("fill");
                markerRectangle.set("fill", fill);
              }
            }
          }
        }
        this.updateLegendMarker(undefined);
      }
      if (this.bullets.length > 0) {
        var _startIndex = this.startIndex();
        var _endIndex = this.endIndex();
        if (_endIndex < this.dataItems.length) {
          _endIndex++;
        }
        for (var i = _startIndex; i < _endIndex; i++) {
          var dataItem = this.dataItems[i];
          if (!dataItem.bullets) {
            this._makeBullets(dataItem);
          }
        }
      }
    }
  }, {
    key: "_calculateAggregates",
    value: function _calculateAggregates(startIndex, endIndex) {
      var _this5 = this;
      var fields = this._valueFields;
      if (!fields) {
        throw new Error("No value fields are set for the series.");
      }
      var sum = {};
      var absSum = {};
      var count = {};
      var low = {};
      var high = {};
      var open = {};
      var close = {};
      var average = {};
      var previous = {};
      $array.each(fields, function (key) {
        sum[key] = 0;
        absSum[key] = 0;
        count[key] = 0;
      });
      $array.each(fields, function (key) {
        var change = key + "Change";
        var changePercent = key + "ChangePercent";
        var changePrevious = key + "ChangePrevious";
        var changePreviousPercent = key + "ChangePreviousPercent";
        var changeSelection = key + "ChangeSelection";
        var changeSelectionPercent = key + "ChangeSelectionPercent";
        var openKey = "valueY";
        if (key == "valueX" || key == "openValueX" || key == "lowValueX" || key == "highValueX") {
          openKey = "valueX";
        }
        var baseValueSeries = _this5.getPrivate("baseValueSeries");
        for (var i = startIndex; i < endIndex; i++) {
          var dataItem = _this5.dataItems[i];
          var value = dataItem.get(key);
          if (value != null) {
            count[key]++;
            sum[key] += value;
            absSum[key] += Math.abs(value);
            average[key] = sum[key] / count[key];
            if (low[key] > value || low[key] == null) {
              low[key] = value;
            }
            if (high[key] < value || high[key] == null) {
              high[key] = value;
            }
            close[key] = value;
            if (open[key] == null) {
              open[key] = value;
              previous[key] = value;
              if (baseValueSeries) {
                open[openKey] = baseValueSeries._getBase(openKey);
              }
            }
            if (startIndex === 0) {
              dataItem.setRaw(change, value - open[openKey]);
              dataItem.setRaw(changePercent, (value - open[openKey]) / open[openKey] * 100);
            }
            dataItem.setRaw(changePrevious, value - previous[openKey]);
            dataItem.setRaw(changePreviousPercent, (value - previous[openKey]) / previous[openKey] * 100);
            dataItem.setRaw(changeSelection, value - open[openKey]);
            dataItem.setRaw(changeSelectionPercent, (value - open[openKey]) / open[openKey] * 100);
            previous[key] = value;
          }
        }
      });
      $array.each(fields, function (key) {
        _this5.setPrivate(key + "AverageSelection", average[key]);
        _this5.setPrivate(key + "CountSelection", count[key]);
        _this5.setPrivate(key + "SumSelection", sum[key]);
        _this5.setPrivate(key + "AbsoluteSumSelection", absSum[key]);
        _this5.setPrivate(key + "LowSelection", low[key]);
        _this5.setPrivate(key + "HighSelection", high[key]);
        _this5.setPrivate(key + "OpenSelection", open[key]);
        _this5.setPrivate(key + "CloseSelection", close[key]);
      });
      if (startIndex === 0 && endIndex === this.dataItems.length) {
        $array.each(fields, function (key) {
          _this5.setPrivate(key + "Average", average[key]);
          _this5.setPrivate(key + "Count", count[key]);
          _this5.setPrivate(key + "Sum", sum[key]);
          _this5.setPrivate(key + "AbsoluteSum", absSum[key]);
          _this5.setPrivate(key + "Low", low[key]);
          _this5.setPrivate(key + "High", high[key]);
          _this5.setPrivate(key + "Open", open[key]);
          _this5.setPrivate(key + "Close", close[key]);
        });
      }
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      var _this6 = this;
      _get(_getPrototypeOf(Series.prototype), "_updateChildren", this).call(this);
      this._psi = this.startIndex();
      this._pei = this.endIndex();
      if (this.isDirty("visible")) {
        this.bulletsContainer.set("visible", this.get("visible"));
      }
      // Apply heat rules
      var rules = this.get("heatRules");
      if (this._valuesDirty && rules && rules.length > 0) {
        $array.each(rules, function (rule) {
          var minValue = rule.minValue || _this6.getPrivate(rule.dataField + "Low") || 0;
          var maxValue = rule.maxValue || _this6.getPrivate(rule.dataField + "High") || 0;
          $array.each(rule.target._entities, function (target) {
            var value = target.dataItem.get(rule.dataField);
            if (!$type.isNumber(value)) {
              if (rule.neutral) {
                target.set(rule.key, rule.neutral);
              }
              return;
            }
            var percent;
            if (rule.logarithmic) {
              percent = (Math.log(value) * Math.LOG10E - Math.log(minValue) * Math.LOG10E) / (Math.log(maxValue) * Math.LOG10E - Math.log(minValue) * Math.LOG10E);
            } else {
              percent = (value - minValue) / (maxValue - minValue);
            }
            if ($type.isNumber(value) && (!$type.isNumber(percent) || Math.abs(percent) == Infinity)) {
              percent = 0.5;
            }
            // fixes problems if all values are the same
            var propertyValue;
            if ($type.isNumber(rule.min)) {
              propertyValue = rule.min + (rule.max - rule.min) * percent;
            } else if (rule.min instanceof Color) {
              propertyValue = Color.interpolate(percent, rule.min, rule.max);
            } else if (rule.min instanceof Percent) {
              propertyValue = percentInterpolate(percent, rule.min, rule.max);
            }
            if (rule.customFunction) {
              rule.customFunction.call(_this6, target, minValue, maxValue, value);
            } else {
              target.set(rule.key, propertyValue);
            }
          });
        });
      }
      if (this.bullets.length > 0) {
        var count = this.dataItems.length;
        var startIndex = this.startIndex();
        var endIndex = this.endIndex();
        if (endIndex < count) {
          endIndex++;
        }
        if (startIndex > 0) {
          startIndex--;
        }
        for (var i = 0; i < startIndex; i++) {
          this._hideBullets(this.dataItems[i]);
        }
        for (var _i = startIndex; _i < endIndex; _i++) {
          this._positionBullets(this.dataItems[_i]);
        }
        for (var _i2 = endIndex; _i2 < count; _i2++) {
          this._hideBullets(this.dataItems[_i2]);
        }
      }
    }
  }, {
    key: "_positionBullets",
    value: function _positionBullets(dataItem) {
      var _this7 = this;
      if (dataItem.bullets) {
        $array.each(dataItem.bullets, function (bullet) {
          _this7._positionBullet(bullet);
          var sprite = bullet.get("sprite");
          if (bullet.get("dynamic")) {
            if (sprite) {
              sprite._markDirtyKey("fill");
              sprite.markDirtySize();
            }
            if (sprite instanceof Container) {
              sprite.walkChildren(function (child) {
                child._markDirtyKey("fill");
                child.markDirtySize();
                if (child instanceof Label) {
                  child.text.markDirtyText();
                }
              });
            }
          }
          if (sprite instanceof Label && sprite.get("populateText")) {
            sprite.text.markDirtyText();
          }
        });
      }
    }
  }, {
    key: "_hideBullets",
    value: function _hideBullets(dataItem) {
      if (dataItem.bullets) {
        $array.each(dataItem.bullets, function (bullet) {
          var sprite = bullet.get("sprite");
          if (sprite) {
            sprite.setPrivate("visible", false);
          }
        });
      }
    }
  }, {
    key: "_positionBullet",
    value: function _positionBullet(_bullet) {}
  }, {
    key: "_placeBulletsContainer",
    value: function _placeBulletsContainer(chart) {
      chart.bulletsContainer.children.moveValue(this.bulletsContainer);
    }
  }, {
    key: "_removeBulletsContainer",
    value: function _removeBulletsContainer() {
      var bulletsContainer = this.bulletsContainer;
      if (bulletsContainer.parent) {
        bulletsContainer.parent.children.removeValue(bulletsContainer);
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "disposeDataItem",
    value: function disposeDataItem(dataItem) {
      //super.disposeDataItem(dataItem); // does nothing
      var bullets = dataItem.bullets;
      if (bullets) {
        $array.each(bullets, function (bullet) {
          bullet.dispose();
        });
      }
    }
  }, {
    key: "_getItemReaderLabel",
    value: function _getItemReaderLabel() {
      return "";
    }
    /**
     * Shows series's data item.
     *
     * @param   dataItem  Data item
     * @param   duration  Animation duration in milliseconds
     * @return            Promise
     */
  }, {
    key: "showDataItem",
    value: function showDataItem(dataItem, duration) {
      var _this8 = this;
      var _super = Object.create(null, {
        showDataItem: {
          get: function get() {
            return _get(_getPrototypeOf(Series.prototype), "showDataItem", _this8);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var promises, bullets;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              promises = [_super.showDataItem.call(this, dataItem, duration)];
              bullets = dataItem.bullets;
              if (bullets) {
                $array.each(bullets, function (bullet) {
                  promises.push(bullet.get("sprite").show(duration));
                });
              }
              _context.next = 5;
              return Promise.all(promises);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Hides series's data item.
     *
     * @param   dataItem  Data item
     * @param   duration  Animation duration in milliseconds
     * @return            Promise
     */
  }, {
    key: "hideDataItem",
    value: function hideDataItem(dataItem, duration) {
      var _this9 = this;
      var _super = Object.create(null, {
        hideDataItem: {
          get: function get() {
            return _get(_getPrototypeOf(Series.prototype), "hideDataItem", _this9);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var promises, bullets;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              promises = [_super.hideDataItem.call(this, dataItem, duration)];
              bullets = dataItem.bullets;
              if (bullets) {
                $array.each(bullets, function (bullet) {
                  promises.push(bullet.get("sprite").hide(duration));
                });
              }
              _context2.next = 5;
              return Promise.all(promises);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "_sequencedShowHide",
    value: function _sequencedShowHide(show, duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this10 = this;
        var startIndex, endIndex;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.get("sequencedInterpolation")) {
                _context4.next = 11;
                break;
              }
              if (!$type.isNumber(duration)) {
                duration = this.get("interpolationDuration", 0);
              }
              if (!(duration > 0)) {
                _context4.next = 9;
                break;
              }
              startIndex = this.startIndex();
              endIndex = this.endIndex();
              _context4.next = 7;
              return Promise.all($array.map(this.dataItems, function (dataItem, i) {
                return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var realDuration, delay;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        realDuration = duration || 0;
                        if (i < startIndex - 10 || i > endIndex + 10) {
                          realDuration = 0;
                        }
                        //let delay = this.get("sequencedDelay", 0) * i + realDuration * (i - startIndex) / (endIndex - startIndex);
                        delay = this.get("sequencedDelay", 0) + realDuration / (endIndex - startIndex);
                        _context3.next = 5;
                        return $time.sleep(delay * (i - startIndex));
                      case 5:
                        if (!show) {
                          _context3.next = 10;
                          break;
                        }
                        _context3.next = 8;
                        return this.showDataItem(dataItem, realDuration);
                      case 8:
                        _context3.next = 12;
                        break;
                      case 10:
                        _context3.next = 12;
                        return this.hideDataItem(dataItem, realDuration);
                      case 12:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, this);
                }));
              }));
            case 7:
              _context4.next = 11;
              break;
            case 9:
              _context4.next = 11;
              return Promise.all($array.map(this.dataItems, function (dataItem) {
                if (show) {
                  return _this10.showDataItem(dataItem, 0);
                } else {
                  return _this10.hideDataItem(dataItem, 0);
                }
              }));
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * @ignore
     */
  }, {
    key: "updateLegendValue",
    value: function updateLegendValue(dataItem) {
      if (dataItem) {
        var legendDataItem = dataItem.get("legendDataItem");
        if (legendDataItem) {
          var valueLabel = legendDataItem.get("valueLabel");
          if (valueLabel) {
            var text = valueLabel.text;
            var txt = "";
            valueLabel._setDataItem(dataItem);
            txt = this.get("legendValueText", text.get("text", ""));
            valueLabel.set("text", txt);
            text.markDirtyText();
          }
          var label = legendDataItem.get("label");
          if (label) {
            var _text = label.text;
            var _txt = "";
            label._setDataItem(dataItem);
            _txt = this.get("legendLabelText", _text.get("text", ""));
            label.set("text", _txt);
            _text.markDirtyText();
          }
        }
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateLegendMarker",
    value: function updateLegendMarker(_dataItem) {}
  }, {
    key: "_onHide",
    value: function _onHide() {
      _get(_getPrototypeOf(Series.prototype), "_onHide", this).call(this);
      var tooltip = this.getTooltip();
      if (tooltip) {
        tooltip.hide();
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "hoverDataItem",
    value: function hoverDataItem(_dataItem) {}
    /**
     * @ignore
     */
  }, {
    key: "unhoverDataItem",
    value: function unhoverDataItem(_dataItem) {}
    /**
     * @ignore
     */
  }, {
    key: "_getBase",
    value: function _getBase(key) {
      var dataItem = this.dataItems[this.startIndex()];
      if (dataItem) {
        return dataItem.get(key);
      }
      return 0;
    }
  }]);
  return Series;
}(Component);
Object.defineProperty(Series, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Series"
});
Object.defineProperty(Series, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Component.classNames.concat([Series.className])
});